import component from './OtherPost';
import handles from './handles';

export default {
  component,
  handles,
};



// WEBPACK FOOTER //
// ./src/components/OtherPost/index.js